/** Перевод интерфейса: китайский. Ключ — русская фраза, {n} и т.п. — подстановки. */
export const zh: Record<string, string> = {
  "дд.мм.гггг": "日.月.年",
  "Дата в формате дд.мм.гггг": "日期格式：日.月.年",
  "Календарь": "日历",
  "Здесь появятся проведённые запросы и закупки.": "已提交的需求单和采购将显示在这里。",
  "Меню": "菜单",
  "Демо-данные": "演示数据",
  "Язык интерфейса": "界面语言",
  "Светлая тема": "浅色主题",
  "Тёмная тема": "深色主题",
  "Тема": "主题",
  "Журнал действий": "操作日志",
  "Не удалось сохранить название": "无法保存名称",
  "Загрузить демонстрационные данные?": "加载演示数据？",
  "Текущие запросы и закупки будут заменены демонстрационным набором.": "当前的需求单和采购将被演示数据替换。",
  "Загрузить заново": "重新加载",
  "Отмена": "取消",
  "Демонстрационные данные загружены заново.": "演示数据已重新加载。",
  "Не удалось загрузить": "加载失败",
  "Двойной щелчок — переименовать": "双击以重命名",
  "Учёт запчастей": "配件管理",
  "Запросы и закупки": "需求与采购",
  "В работе: {n}, просрочено: {m}": "进行中：{n}，已逾期：{m}",
  "В работе: {n}": "进行中：{n}",
  "Сервис": "服务",
  "Проверка сервера": "服务器检查",
  "сменить роль": "切换角色",
  "Работать как": "切换为",
  "Переименовать приложение": "重命名应用",
  "Загрузить демо-данные": "加载演示数据",
  "Новый запрос": "新需求单",
  "Закупка": "采购",
  "Текущие запросы": "当前需求单",
  "Статистика": "统计",
  "Нет строк": "没有数据",
  "Проверка": "检查",
  "Готово": "就绪",
  "не переносить": "不导入",
  "Загрузка ответа фабрики": "导入工厂回复",
  "Загрузите файл, который вернула фабрика. Строки сопоставляются по OEM, значения попадут в таблицу — провести их нужно будет как обычно, кнопкой «Проверить и провести».": "上传工厂返回的文件。按 OEM 匹配行，数据会填入表格，之后照常点击「检查并提交」。",
  "Выбрать файл .xlsx": "选择 .xlsx 文件",
  "Лист": "工作表",
  "Строка заголовков": "标题行",
  "Строка {n}": "第 {n} 行",
  "Не удалось прочитать файл": "无法读取文件",
  "Обрабатываю…": "处理中…",
  "Столбец с OEM": "OEM 列",
  "Строк: {n}": "行数：{n}",
  "Нет в запросах: {n}": "不在需求单中：{n}",
  "Данные перенесены": "数据已导入",
  "Перенести в таблицу ({n})": "导入表格（{n}）",
  "от {date}": "{date} 创建",
  "на": "金额",
  "закуплено": "已采购",
  "срок {date}": "交期 {date}",
  "Не удалось загрузить данные": "无法加载数据",
  "Повторить": "重试",
  "Загружаю данные…": "正在加载数据…",
  "позиция": "项",
  "позиций": "项",
  "Загружено позиций: {n}": "已加载 {n} 项",
  "Строк с ошибками: {n}. Исправьте их (см. столбец «Проверка»).": "有错误的行：{n}。请修正（见「检查」列）。",
  "Нельзя провести": "无法提交",
  "Ошибка": "错误",
  "Не проведено": "未提交",
  "Запрос № {no} проведён": "需求单 {no} 已提交",
  "отдел продаж: запрос клиента или правки к проведённому": "销售部：客户需求或修改已提交的需求单",
  "Он виден отделу закупки и на экране": "采购部现在可以看到它，也可在以下页面查看：",
  "Роль «{role}» может заполнять форму, но не проводить запросы. Сменить роль можно внизу боковой панели.": "「{role}」角色可以填写表单，但不能提交需求单。可在侧栏底部切换角色。",
  "Выберите запрос": "选择需求单",
  "Не найдено": "未找到",
  "Сегодня, {date}": "今天，{date}",
  "Вставьте таблицу клиента в таблицу ниже: OEM, наименование, количество, цена.": "将客户表格粘贴到下方：OEM、名称、数量、价格。",
  "Выберите номер запроса — его состав загрузится в таблицу.": "选择需求单号，其明细会加载到表格中。",
  "Загрузить состав": "加载明细",
  "Очистить таблицу": "清空表格",
  "Скрыть инструкцию": "隐藏说明",
  "Как заполнять": "填写说明",
  "Позиций": "项数",
  "Штук": "件数",
  "Сумма": "金额",
  "С ошибками": "有错误",
  "Проверить и провести": "检查并提交",
  "Таблица работает как в Excel: щелчок выделяет ячейку, двойной щелчок, Enter или начало набора — правка. Ctrl+C и Ctrl+V, выделение мышью, ширина столбцов запоминается.": "表格用法与 Excel 相同：单击选中单元格，双击、按 Enter 或直接输入即可编辑。支持 Ctrl+C / Ctrl+V 和鼠标框选，列宽会被记住。",
  "{n} млн": "{n}百万",
  "{n} тыс": "{n}千",
  "по всем запросам и закупкам": "所有需求单与采购",
  "Не удалось загрузить статистику": "无法加载统计",
  "Считаю статистику…": "正在计算统计…",
  "Запросов": "需求单",
  "в работе {n}": "进行中 {n}",
  "Сумма запросов": "需求金额",
  "Выручка по закупленному": "已采购收入",
  "{n} шт закуплено": "已采购 {n} 件",
  "Маржа": "毛利",
  "{n} % от выручки": "占收入 {n}%",
  "Суммы запросов по месяцам": "每月需求金额",
  "Запрошено": "需求",
  "Выручка, затраты и маржа": "收入、成本与毛利",
  "Выручка": "收入",
  "Затраты": "成本",
  "Цены фабрики": "工厂价格",
  "CNY за штуку": "元/件",
  "Пока мало данных: цена фабрики должна быть внесена хотя бы за два месяца.": "数据不足：工厂价格至少需要两个月的记录。",
  "Изменение цен фабрики": "工厂价格变化",
  "Наименование": "名称",
  "Было": "原值",
  "Стало": "新值",
  "Изменение": "变化",
  "Изменений цен пока нет.": "暂无价格变化。",
  "Топ позиций по закупленной сумме": "按采购金额排名",
  "Закуплено, шт": "已采购，件",
  "Выручка, CNY": "收入，元",
  "Доля": "占比",
  "Маржа, CNY": "毛利，元",
  "Последний месяц к предыдущему": "本月与上月相比",
  "Нет заполненных строк. Заполните «Закупить».": "没有已填写的行。请填写「采购数量」。",
  "Нет заполненных строк. Заполните наличие и цену.": "没有已填写的行。请填写库存和价格。",
  "Проведено: {title}": "已提交：{title}",
  "наличие и цены фабрики, закупка по запросам": "工厂库存与价格，按需求单采购",
  "Данные пересчитаны.": "数据已重新计算。",
  "Роль «{role}» может заполнять форму, но не проводить. Сменить роль можно внизу боковой панели.": "「{role}」角色可以填写表单，但不能提交。可在侧栏底部切换角色。",
  "Все открытые запросы": "所有未完成需求单",
  "Закупка распределится по открытым запросам по очереди, от старых к новым.": "采购将按顺序分配到未完成需求单，从最早的开始。",
  "Все OEM, которые ещё нужно закупить по открытым запросам.": "未完成需求单中仍需采购的全部 OEM。",
  "Запрос не выбран — выберите номер, чтобы подставить OEM.": "未选择需求单，请选择单号以填入 OEM。",
  "Загрузить OEM запроса": "加载需求单 OEM",
  "Выгрузить для фабрики": "导出给工厂",
  "Загрузить ответ фабрики": "导入工厂回复",
  "Заполнено строк": "已填写行",
  "Закупить": "采购数量",
  "шт": "件",
  "Обратите внимание": "请注意",
  "У текущей роли нет прав на проведение.": "当前角色没有提交权限。",
  "Провести": "提交",
  "снято {n}": "已撤销 {n}",
  "№ запроса / OEM": "需求单号 / OEM",
  "OEM от закупки": "采购建议 OEM",
  "Требуемое кол-во, шт": "需求数量，件",
  "Цена для клиента, CNY": "客户单价，元",
  "Сумма для клиента, CNY": "客户金额，元",
  "Цена фабрики, CNY": "工厂单价，元",
  "Сумма фабрики, CNY": "工厂金额，元",
  "Уже закуплено, шт": "已采购，件",
  "Закуплено на сумму для клиента, CNY": "已采购客户金额，元",
  "Нужно закупить, шт": "待采购，件",
  "Излишек, шт": "超量，件",
  "Статус": "状态",
  "Автор": "创建人",
  "Комментарий / примечание": "备注",
  "Не удалось загрузить запросы": "无法加载需求单",
  "что заказал клиент, что закуплено и что осталось": "客户订了什么、已采购多少、还剩多少",
  "Номер запроса, OEM, наименование": "需求单号、OEM、名称",
  "Очистить поиск": "清除搜索",
  "Фильтр по статусу": "按状态筛选",
  "Развернуть все запросы": "展开全部需求单",
  "Развернуть": "展开",
  "Свернуть все запросы": "收起全部需求单",
  "Свернуть": "收起",
  "Загружаю запросы…": "正在加载需求单…",
  "Нет запросов — измените фильтр или поиск": "没有需求单，请调整筛选或搜索",
  "Запросов в списке": "列表中的需求单",
  "Сумма для клиента": "客户金额",
  "Закуплено": "已采购",
  "{a} из {b} шт": "{a} / {b} 件",
  "Нужно закупить": "待采购",
  "Все": "全部",
  "В работе": "进行中",
  "Просрочены": "已逾期",
  "Выполнены": "已完成",
  "Отменены": "已取消",
  "Версия {v}. Проверка сервера и базы данных.": "版本 {v}。服务器与数据库检查。",
  "К приложению": "返回应用",
  "Проверяю…": "检查中…",
  "Всё работает": "一切正常",
  "Есть проблема": "存在问题",
  "Сервер": "服务器",
  "работает, {time}": "运行中，{time}",
  "База данных": "数据库",
  "Папка базы": "数据库文件夹",
  "Сервер базы": "数据库服务器",
  "Миграции": "迁移",
  "База создана": "数据库创建时间",
  "Время сервера": "服务器时间",
  "Москва": "莫斯科",
  "Что проверить": "检查事项",
  "Открыто ли окно консоли, которое запустил start.bat. Если окно закрыто — запустите start.bat снова. Если открыто — ошибка будет видна в нём: пришлите последние строки.": "由 start.bat 启动的控制台窗口是否打开？如果已关闭，请重新运行 start.bat；如果打开着，错误会显示在其中，请发送最后几行。",
  "Проверено в {time}": "检查时间 {time}",
  "Проверить ещё раз": "再次检查",
  "встроенная": "内置",
  "сервер": "服务器",
  "подключена ({kind}), PostgreSQL {v}, отклик {ms} мс": "已连接（{kind}），PostgreSQL {v}，响应 {ms} 毫秒",
  "{n} с": "{n} 秒",
  "{n} мин": "{n} 分钟",
  "{h} ч {m} мин": "{h} 小时 {m} 分钟",
  "Уменьшить таблицу": "缩小表格",
  "Увеличить таблицу": "放大表格",
  "Масштаб таблиц (Ctrl + колёсико над таблицей)": "表格缩放（在表格上按住 Ctrl 滚动滚轮）",
  "{n}% — обычный": "{n}% — 正常",
  "Развернуть панель": "展开侧栏",
  "Свернуть панель": "收起侧栏",
  "История": "历史记录",
  "изменений: {n}": "变更：{n}",
  "Время / OEM": "时间 / OEM",
  "Действие": "操作",
  "Наименование / подробности": "名称 / 详情",
  "Что изменилось": "变更内容",
  "Не удалось загрузить историю": "无法加载历史记录",
  "кто, когда и что изменил": "谁在何时修改了什么",
  "OEM, № запроса, наименование": "OEM、需求单号、名称",
  "Тип действия": "操作类型",
  "Все авторы": "全部人员",
  "Развернуть все": "全部展开",
  "Свернуть все": "全部收起",
  "Загружаю историю…": "正在加载历史记录…",
  "Нет действий — измените фильтр или поиск": "没有记录，请调整筛选或搜索",
  "Запросы": "需求单",
  "Наличие и закупка": "库存与采购",
  "Прочее": "其他",
  "Нет изменений для проведения: обновите наличие или цену либо заполните «Закупить».": "没有可提交的变更：请更新库存或价格，或填写「采购数量」。",
  "Изменено строк": "已修改行",
  "Последнее проверенное наличие за вычетом закупленного после проверки": "最近核查的库存减去此后已采购的数量",
  "Дата наличия": "库存日期",
  "Выгрузка в Excel": "导出到 Excel",
  "Какие запросы": "哪些需求单",
  "Все запросы": "全部需求单",
  "Столбцы": "列",
  "Выбрать все": "全选",
  "Снять все": "全不选",
  "Выбор столбцов запоминается.": "列的选择会被记住。",
  "Выгрузить": "导出",
  "Закрыть по закупленному и перенести недокупленное в новый запрос": "按已采购数量关闭，并将未采购部分转入新需求单",
  "Доступно отделу продаж и администратору": "仅销售部和管理员可用",
  "Перенести остаток": "转移剩余",
  "снятых: {n}": "已撤销：{n}",
  "без закупок": "无采购",
  "Нельзя перенести": "无法转移",
  "Остаток перенесён": "剩余已转移",
  "Закрыть по закупленному и перенести остаток": "按已采购关闭并转移剩余",
  "В исходном запросе требуемое количество станет равным закупленному, а недокупленное попадёт в новый запрос. Закупки не меняются.": "原需求单的需求数量将改为已采购数量，未采购部分转入新需求单。采购记录不变。",
  "Один запрос": "单个需求单",
  "Из какого запроса": "从哪个需求单",
  "Нет запросов с недокупленным": "没有未采购完的需求单",
  "Включать запросы без закупок": "包括无采购的需求单",
  "Такие запросы перейдут целиком, исходные станут «Отменено».": "这些需求单将整体转移，原需求单变为「已取消」。",
  "Включать позиции, снятые клиентом": "包括客户撤销的项目",
  "Вернутся в новый запрос в количестве до снятия. Каждая переносится только один раз.": "将按撤销前的数量转入新需求单，每项只转移一次。",
  "№ нового запроса": "新需求单号",
  "Пусто — «Остаток из запроса № …»": "留空则为「来自需求单 … 的剩余」",
  "Предпросмотр": "预览",
  "Закрыть и создать запрос": "关闭并创建需求单",
  "Частично": "部分",
  "Ожидает": "待采购",
  "Не отменено": "未撤销",
  "Действие отменено": "操作已撤销",
  "Отменить последнее действие": "撤销最近一次操作",
  "Отменять нечего: проведённых действий нет.": "没有可撤销的操作。",
  "Данные вернутся к состоянию до этого действия: запросы — к прежнему составу, добавленные записи будут удалены. Отменять можно по одному действию, начиная с последнего.": "数据将恢复到该操作之前的状态：需求单恢复原有明细，新增的记录将被删除。只能从最近一次开始逐个撤销。",
  "Отменить действие": "撤销操作",
  "Пароли не совпадают.": "两次输入的密码不一致。",
  "Имя и пароль": "姓名和密码",
  "Имя": "姓名",
  "Оно будет видно в истории действий.": "将显示在操作历史中。",
  "Сохранить имя": "保存姓名",
  "Сменить пароль": "修改密码",
  "Текущий пароль": "当前密码",
  "Новый пароль": "新密码",
  "Не короче {n} символов.": "至少 {n} 个字符。",
  "Пароль ещё раз": "再次输入密码",
  "Пользователи": "用户",
  "Ждут подтверждения: {n}": "待批准：{n}",
  "Выйти": "退出登录",
  "Роль «{role}» может заполнять форму, но не проводить запросы. Права выдаёт администратор.": "「{role}」角色可以填写表单，但不能提交需求单。权限由管理员分配。",
  "Роль «{role}» может заполнять форму, но не проводить. Права выдаёт администратор.": "「{role}」角色可以填写表单，但不能提交。权限由管理员分配。",
  "Удалить пользователя {name}?": "删除用户 {name}？",
  "Войти он больше не сможет. Его действия в истории сохранятся.": "该用户将无法再登录，其操作记录会保留在历史中。",
  "Удалить": "删除",
  "это вы": "您本人",
  "Подтвердить": "批准",
  "Действия": "操作",
  "Задать новый пароль": "设置新密码",
  "Отключить": "停用",
  "Включить": "启用",
  "Пользователь": "用户",
  "Роль": "角色",
  "Последний вход": "最近登录",
  "доступ, роли и заявки на вход": "访问权限、角色和注册申请",
  "Добавить пользователя": "添加用户",
  "Ждут подтверждения": "待批准",
  "Выберите роль и нажмите «Подтвердить» — после этого человек сможет войти.": "选择角色并点击「批准」，之后该用户即可登录。",
  "Роли: «Продажи» — запросы клиента и перенос остатка; «Закупки» — наличие и закупка; «Администратор» — всё, включая пользователей и отмену действий.": "角色：「销售」——客户需求和剩余转移；「采购部」——库存与采购；「管理员」——全部权限，包括用户管理和撤销操作。",
  "E-mail": "电子邮箱",
  "Пароль": "密码",
  "Не короче {n} символов. Сообщите его пользователю — сменить можно в меню «Имя и пароль».": "至少 {n} 个字符。请告知用户，可在「姓名和密码」中修改。",
  "Добавить": "添加",
  "Новый пароль: {name}": "新密码：{name}",
  "Не короче {n} символов. Пользователь выйдет со всех устройств.": "至少 {n} 个字符。该用户将在所有设备上退出登录。",
  "Сохранить": "保存",
  "Вход": "登录",
  "Регистрация": "注册",
  "Войти": "登录",
  "Отправить заявку": "提交申请",
  "Войти можно будет после того, как администратор подтвердит доступ и назначит роль.": "管理员批准并分配角色后即可登录。",
  "Работает": "正常",
  "Ждёт подтверждения": "待批准",
  "Отключён": "已停用",
  "E-mail или логин": "电子邮箱或登录名",
  "На ПК: открыто ли окно консоли, которое запустил start.bat (если закрыто — запустите снова; если открыто — пришлите последние строки из него). На сервере: выполните sudo partsctl status и sudo partsctl logs.": "在电脑上：start.bat 启动的控制台窗口是否打开（若已关闭请重新运行；若已打开请发送最后几行）。在服务器上：运行 sudo partsctl status 和 sudo partsctl logs。",
  "Запросов нет": "没有需求单",
  "Строк с ошибками: {n}": "有错误的行：{n}",
  "Строки {rows}. Причина — в столбце «Проверка» этих строк.": "第 {rows} 行。原因见这些行的「检查」列。",
  "Причина — в столбце «Проверка».": "原因见「检查」列。",
  "Открыт": "待处理",
  "Частично выполнен": "部分完成",
  "Выполнен": "已完成",
  "Просрочен": "已逾期",
  "Отменено": "已取消",
  "Ожидает закупки": "待采购",
  "Частично закуплено": "部分采购",
  "Излишек": "超量",
  "Администратор": "管理员",
  "Продажи": "销售",
  "Закупки": "采购部",
  "Система": "系统",
  "Изменение запроса": "修改需求单",
  "Наличие и цены фабрики": "工厂库存与价格",
  "OEM": "OEM",
  "Количество, шт": "数量，件",
  "Цена продажи, CNY": "销售单价，元",
  "Примечание": "备注",
  "Требуется, шт": "需求，件",
  "В наличии у фабрики, шт": "工厂现有库存，件",
  "Наличие у фабрики, шт": "工厂库存，件",
  "Закупить, шт": "采购数量，件",
  "HS code": "HS 编码",
  "№ партии": "批次号",
  "№ коробки": "箱号",
  "№ запроса": "需求单号",
  "Дата": "日期",
  "Срок поставки": "交货期",
  "Комментарий": "备注",
  "Дата операции": "操作日期",
  "Поставщик": "供应商",
  "№ счёта": "发票号",
  "Необязательно": "选填",
  "Уникальный номер нового запроса": "新需求单的唯一编号",
  "Выберите номер — состав загрузится сам": "选择单号，明细会自动加载",
  "Дата таблицы клиента (пусто — сегодня)": "客户表格日期（留空为今天）",
  "Дата правки (пусто — сегодня)": "修改日期（留空为今天）",
  "Заполняется позже, когда срок станет известен": "交期确定后再填写",
  "Выберите запрос — OEM подставятся сами. «Все открытые запросы» — вся текущая потребность": "选择需求单，OEM 会自动填入。「所有未完成需求单」表示全部当前需求",
  "Выберите запрос — OEM подставятся сами, закупка закрепится за ним. «Все открытые запросы» — по очереди от старых к новым": "选择需求单，OEM 会自动填入，采购将归属于该需求单。「所有未完成需求单」按从旧到新的顺序分配",
  "Дата проверки наличия, закупки или упаковки (пусто — сегодня)": "库存核查或采购日期（留空为今天）",
  "Фабрика или поставщик": "工厂或供应商",
  "Номер счёта фабрики": "工厂发票号",
  "Заполните номер запроса и вставьте таблицу клиента: OEM, наименование, количество, цена.": "填写需求单号并粘贴客户表格：OEM、名称、数量、价格。",
  "Цена — та, по которой продаём клиенту. По ней считаются суммы и маржа.": "价格为我们卖给客户的价格，金额和毛利据此计算。",
  "Номер должен быть новым: если такой запрос уже есть, переключитесь в режим «Изменение запроса».": "单号必须是新的：如果该需求单已存在，请切换到「修改需求单」。",
  "Выберите номер запроса — текущий состав загрузится в таблицу.": "选择需求单号，当前明细会加载到表格。",
  "Поправьте количества и цены, добавьте новые строки. Чтобы снять позицию, поставьте количество 0 или удалите строку.": "调整数量和价格，或添加新行。要撤销某项，将数量设为 0 或删除该行。",
  "Можно вставить новую таблицу клиента целиком: позиций, которых в ней нет, станет 0.": "可以粘贴整份新的客户表格：表中没有的项目数量将变为 0。",
  "Если запрос нужно закрыть частично, поставьте нужные количества — остальное останется в работе.": "如需部分关闭需求单，填写所需数量，其余部分仍保持进行中。",
  "Выберите запрос — OEM подставятся автоматически. «Требуется» — сколько ещё нужно закупить.": "选择需求单，OEM 会自动填入。「需求」为仍需采购的数量。",
  "Для каждой строки обязательны наличие у фабрики и цена; HS code желательно заполнить (подставляется, если уже вносился).": "每行必须填写工厂库存和价格；建议填写 HS 编码（之前录入过会自动填入）。",
  "Если OEM нужно изменить — укажите правильный в столбце «OEM от закупки»: отдел продаж получит уведомление.": "如需更改 OEM，请在「采购建议 OEM」列填写正确的编号，销售部会收到通知。",
  "Строки без наличия и цены не проводятся.": "没有库存和价格的行不会提交。",
  "Заполните «Закупить». Цена фабрики, HS code и «OEM от закупки» подставляются из режима «Наличие и цены фабрики» — исправьте цену, если она изменилась.": "填写「采购数量」。工厂价格、HS 编码和「采购建议 OEM」来自「工厂库存与价格」，价格有变时请修改。",
  "Выбран конкретный запрос — закупка закрепляется за ним, и больше, чем требуется по этому запросу, закупить нельзя.": "选择了具体需求单时，采购归属于该需求单，且不能超过该需求单的需求量。",
  "«Все открытые запросы» — закупка распределяется по очереди от старых запросов к новым, лимит — общая потребность по OEM.": "「所有未完成需求单」：采购按从旧到新的顺序分配，上限为该 OEM 的总需求量。",
  "Нельзя закупить больше, чем «В наличии у фабрики» (если наличие проверялось). Строки без «Закупить» не проводятся.": "采购量不能超过「工厂现有库存」（如已核查库存）。没有「采购数量」的行不会提交。",
  "Загружено строк: {n}": "已加载 {n} 行",
  "Сначала выберите № запроса.": "请先选择需求单号。",
  "Выбранный запрос не найден.": "未找到所选需求单。",
  "Нет позиций: всё уже закуплено.": "没有项目：已全部采购。",
  "Нет OEM": "缺少 OEM",
  "OEM не найден в запросах": "需求单中没有该 OEM",
  "Дубль OEM": "OEM 重复",
  "Наличие не число": "库存不是数字",
  "Цена не число": "价格不是数字",
  "«Закупить» не число": "「采购数量」不是数字",
  "Отрицательное значение": "数值为负",
  "Кол-во не целое": "数量不是整数",
  "Не указано наличие": "未填写库存",
  "Не указана цена": "未填写价格",
  "Не указано «Закупить»": "未填写「采购数量」",
  "«Закупить» должно быть больше 0": "「采购数量」必须大于 0",
  "Выбранный запрос не найден": "未找到所选需求单",
  "OEM нет в выбранном запросе (или снят клиентом)": "所选需求单中没有该 OEM（或已被客户撤销）",
  "По запросу уже закуплено полностью": "该需求单已全部采购",
  "Больше, чем нужно по запросу (макс. {n})": "超过需求单需求量（最多 {n}）",
  "Потребность по OEM уже закрыта": "该 OEM 的需求已满足",
  "Больше общей потребности (макс. {n})": "超过总需求量（最多 {n}）",
  "Больше наличия у фабрики (доступно {n})": "超过工厂库存（可用 {n}）",
  "Не указано количество": "未填写数量",
  "Кол-во не число": "数量不是数字",
  "Кол-во меньше 0": "数量小于 0",
  "Кол-во 0 в новом запросе": "新需求单中数量为 0",
  "Цена меньше 0": "价格小于 0",
  "Нет заполненных строк для проведения. Заполните наличие, цену или «Закупить».": "没有可提交的行。请填写库存、价格或「采购数量」。",
  "Строк с ошибками: {n}. Исправьте их (см. столбец «Проверка») и повторите.": "有错误的行：{n}。请修正（见「检查」列）后重试。",
  "Дата операции указана некорректно.": "操作日期无效。",
  "Выбранный запрос не найден. Выберите номер из списка.": "未找到所选需求单，请从列表中选择。",
  "{n} (без изменений)": "{n}（未变）",
  "Наличие, шт": "库存，件",
  "К закупке, шт": "待采购，件",
  "Можно купить сейчас, шт": "现在可买，件",
  "Закупка по запросу № {no}": "需求单 {no} 的采购",
  "Закупка по всем открытым запросам": "所有未完成需求单的采购",
  "Нужно по запросу, шт": "需求单需求，件",
  "Нужно по всем запросам, шт": "全部需求单需求，件",
  "OEM от закупки (для отдела продаж)": "采购建议 OEM（给销售部）",
  "Сумма по ценам фабрики": "按工厂价格计算的金额",
  "Режим": "模式",
  "Запрос": "需求单",
  "все открытые запросы": "所有未完成需求单",
  "«Можно купить сейчас» — меньшее из «К закупке» и нового наличия.": "「现在可买」取「待采购」与新库存中的较小值。",
  "Закупка будет закреплена за запросом № {no}.": "采购将归属于需求单 {no}。",
  "Закупка будет распределена по открытым запросам по очереди, начиная с самого старого.": "采购将按顺序分配到未完成需求单，从最早的开始。",
  "Цена фабрики изменится у позиций: {n} (показано стрелкой).": "{n} 项的工厂价格将变化（用箭头标出）。",
  "Отдел продаж получит предложения по OEM: {n}.": "销售部将收到 {n} 条 OEM 建议。",
  "Не указан поставщик.": "未填写供应商。",
  "Не указан № счёта.": "未填写发票号。",
  "запрос № {no}": "需求单 {no}",
  "счёт {n}": "发票 {n}",
  "Всего, шт": "合计，件",
  "Кол-во, шт": "数量，件",
  "Укажите № запроса.": "请填写需求单号。",
  "Дата указана некорректно.": "日期无效。",
  "Срок поставки указан некорректно.": "交货期无效。",
  "Запрос № {no} уже существует. Для правок выберите режим «Изменение запроса».": "需求单 {no} 已存在。如需修改，请选择「修改需求单」。",
  "Нет строк для проведения.": "没有可提交的行。",
  "Запрос № {no} не найден. Выберите номер из списка.": "未找到需求单 {no}，请从列表中选择。",
  "Нет в актуальной таблице клиента": "不在客户最新表格中",
  "Изменений нет: таблица совпадает с текущим состоянием запроса № {no}.": "没有变化：表格与需求单 {no} 当前内容一致。",
  "Новые позиции": "新增项目",
  "Добавлено": "已添加",
  "Изменено": "已修改",
  "Удалено (количество станет 0)": "已撤销（数量变为 0）",
  "Без изменений: {n} поз.": "未变：{n} 项",
  "Снимается позиций: {n}. Уже закупленное по ним останется как излишек.": "撤销 {n} 项。已采购的部分将作为超量保留。",
  "Новый запрос № {no}": "新需求单 {no}",
  "Изменение запроса № {no}": "修改需求单 {no}",
  "После проведения запрос попадёт в работу к отделу закупки.": "提交后，需求单将转给采购部处理。",
  "Отдел закупки увидит новые количества при следующем выборе запроса.": "采购部下次选择该需求单时会看到新数量。",
  "У роли «{role}» нет прав на {what}.": "「{role}」角色没有{what}的权限。",
  "проведение запросов": "提交需求单",
  "это проведение": "此提交",
  "изменение названия приложения": "修改应用名称",
  "сброс демонстрационных данных": "重置演示数据",
  "База пустая — загружены демонстрационные данные": "数据库为空，已加载演示数据",
  "Демонстрационные данные загружены заново": "演示数据已重新加载",
  "Запрос № {no} не найден.": "未找到需求单 {no}。",
  "Пока был открыт предпросмотр, данные изменились. Откройте предпросмотр заново.": "预览期间数据已变化，请重新打开预览。",
  "Проведено: {title}, позиций: {n}": "已提交：{title}，项数：{n}",
  "Проведено позиций: {n}.": "已提交 {n} 项。",
  "Проведено: {title}, строк: {n}": "已提交：{title}，行数：{n}",
  "Проведено строк: {n}.": "已提交 {n} 行。",
  "Название не может быть пустым.": "名称不能为空。",
  "Нет позиций для выгрузки: всё уже закуплено.": "没有可导出的项目：已全部采购。",
  "Нет такой выгрузки.": "没有该导出。",
  "Выгрузка в Excel: {name}": "导出 Excel：{name}",
  "Сервер не отвечает. Проверьте, что окно приложения (start.bat) открыто.": "服务器无响应。请确认应用窗口（start.bat）已打开。",
  "Ошибка сервера ({n})": "服务器错误（{n}）",
  "№ {no}": "单号 {no}",
  "позиций: {n}": "项数：{n}",
  "строк: {n}": "行数：{n}",
  "изменён срок": "交货期已修改",
  "Название приложения": "应用名称",
  "Демонстрационные данные": "演示数据",
  "Загружены заново": "已重新加载",
  "Загрузка фото": "上传照片",
  "Удаление фото": "删除照片",
  "Основное фото": "主照片",
  "файлов: {n}": "文件：{n}",
  "Упаковка": "包装",
  "инвойс {n}": "发票 {n}",
  "штук: {n}": "件数：{n}",
  "Выберите запрос — подставятся OEM, которые ещё нужно закупить, с последним наличием и ценой. «Все открытые запросы» — вся текущая потребность": "选择需求单，将填入仍需采购的 OEM 及最近的库存和价格。「所有未完成需求单」表示全部当前需求",
  "Дата проверки наличия или закупки (пусто — сегодня)": "库存核查或采购日期（留空为今天）",
  "Выберите запрос — подставятся OEM, которые ещё нужно закупить. Наличие у фабрики, цена, HS code и «OEM от закупки» подтягиваются из прошлых проведений.": "选择需求单，将填入仍需采购的 OEM。工厂库存、价格、HS 编码和「采购建议 OEM」取自以往的提交。",
  "Можно заполнить только наличие и цену — они сохранятся, и в следующий раз останется указать «Закупить». Можно сразу и то и другое.": "可以只填写库存和价格，它们会被保存，下次只需填写「采购数量」。也可以一次全部填写。",
  "Проводятся только строки, где что-то изменилось: новое наличие, цена, HS code, «OEM от закупки» или заполнено «Закупить».": "只提交有变化的行：新的库存、价格、HS 编码、「采购建议 OEM」或已填写「采购数量」。",
  "Выбран конкретный запрос — закупка закрепляется за ним и не может быть больше, чем нужно по нему. «Все открытые запросы» — закупка распределяется от старых запросов к новым.": "选择具体需求单时，采购归属于该需求单且不能超过其需求量。「所有未完成需求单」按从旧到新分配。",
  "Нельзя закупить больше, чем есть у фабрики: берётся введённое в строке наличие, а если его не меняли — последнее известное.": "采购量不能超过工厂库存：使用该行填写的库存，未修改时使用最近已知的库存。",
  "Останется у фабрики, шт": "工厂剩余，件",
  "Обновлено наличие": "已更新库存",
  "Будут сохранены наличие и цены фабрики. «Закупить» можно заполнить позже — наличие подтянется само.": "将保存工厂库存和价格。「采购数量」可稍后填写，库存会自动带出。",
  "дата {d}": "日期 {d}",
  "поставщик: {s}": "供应商：{s}",
  "наличие и цены: {n}": "库存与价格：{n}",
  "закуплено позиций: {n}": "已采购项数：{n}",
  "добавлено: {n}": "新增：{n}",
  "изменено: {n}": "修改：{n}",
  "снято: {n}": "撤销：{n}",
  "Укажите № нового запроса.": "请填写新需求单号。",
  "Запрос № {no} уже существует. Укажите другой номер.": "需求单 {no} 已存在，请使用其他单号。",
  "Выберите запрос, из которого переносится остаток.": "请选择要转移剩余的需求单。",
  "{no} (снято {n})": "{no}（撤销 {n}）",
  "Нечего переносить: по запросу всё закуплено.": "没有可转移的内容：该需求单已全部采购。",
  "Нечего переносить: нет запросов с недокупленными позициями. Проверьте галочки.": "没有可转移的内容：没有未采购完的需求单。请检查选项。",
  "Из запросов № {src}": "来自需求单 {src}",
  "Из запроса № {src}": "来自需求单 {src}",
  "Цены для клиента различались у позиций: {n}. Взята цена самого нового запроса (отмечено ⚠).": "{n} 项的客户价格不一致，采用最新需求单的价格（标记 ⚠）。",
  "Срок поставки нового запроса не указан.": "新需求单未填写交货期。",
  "Остаток из запроса № {src}": "来自需求单 {src} 的剩余",
  "снята клиентом": "客户已撤销",
  "Закрываются по закупленному": "按已采购关闭",
  "Требовалось, шт": "原需求，件",
  "Станет (закуплено), шт": "改为（已采购），件",
  "Переносится, шт": "转移，件",
  "Сумма, CNY": "金额，元",
  "Откуда": "来源",
  "Перенос остатка → новый запрос № {no}": "剩余转移 → 新需求单 {no}",
  "Закрываются": "关闭的需求单",
  "В закрываемых запросах требуемое количество станет равным закупленному (статус «Выполнен»). Недокупленное попадёт в новый запрос. Закупки, упаковка и фото не меняются.": "被关闭需求单的需求数量将改为已采购数量（「已完成」），未采购部分转入新需求单。采购、包装和照片不变。",
  "Запросов закрывается": "关闭的需求单数",
  "Позиций в новом запросе": "新需求单项数",
  "Запрос № {no} уже существует.": "需求单 {no} 已存在。",
  "Закрыт по закупленному, остаток → № {no}": "按已采购关闭，剩余 → {no}",
  "Перенесено {n} шт в запрос № {no}": "{n} 件已转入需求单 {no}",
  "Снятая клиентом позиция перенесена в запрос № {no}": "客户撤销的项目已转入需求单 {no}",
  "Перенос остатка": "剩余转移",
  "Закрыт по закупленному": "按已采购关闭",
  "перенесено позиций: {n}": "转移项数：{n}",
  "Создан запрос № {no}, позиций: {n}.": "已创建需求单 {no}，项数：{n}。",
  "перенос остатка": "转移剩余",
  "Отмена действия": "撤销操作",
  "Отменено: {t}.": "已撤销：{t}。",
  "Отменять нечего.": "没有可撤销的操作。",
  "Последнее действие уже другое. Обновите страницу и проверьте, что отменяете.": "最近一次操作已变化。请刷新页面并确认要撤销的内容。",
  "отмену действий": "撤销操作",
  "Перенос остатка: № {a} → № {b}": "剩余转移：{a} → {b}",
  "Дата выполнения: {d}": "完成日期：{d}",
  "Войдите в приложение.": "请登录。",
  "Неверный e-mail или пароль.": "邮箱或密码错误。",
  "Слишком много неудачных попыток. Подождите 15 минут.": "失败次数过多，请等待 15 分钟。",
  "Доступ ещё не подтверждён администратором.": "管理员尚未批准访问。",
  "Пользователь отключён. Обратитесь к администратору.": "用户已停用，请联系管理员。",
  "Регистрация отключена. Обратитесь к администратору.": "注册已关闭，请联系管理员。",
  "Укажите корректный e-mail.": "请输入有效的电子邮箱。",
  "Укажите имя — оно будет видно в истории действий.": "请输入姓名，它将显示在操作历史中。",
  "Пароль — не короче {n} символов.": "密码至少 {n} 个字符。",
  "Пользователь с таким e-mail уже есть.": "该邮箱已被注册。",
  "Заявка отправлена. Войти можно будет после подтверждения администратором.": "申请已提交，管理员批准后即可登录。",
  "Текущий пароль указан неверно.": "当前密码错误。",
  "Пароль изменён. Войдите заново с новым паролем.": "密码已修改，请使用新密码重新登录。",
  "Укажите имя.": "请输入姓名。",
  "Имя сохранено.": "姓名已保存。",
  "Пользователь не найден.": "未找到用户。",
  "Нельзя: это последний администратор.": "不允许：这是最后一位管理员。",
  "Укажите e-mail.": "请输入电子邮箱。",
  "Выберите роль.": "请选择角色。",
  "Пользователь добавлен.": "用户已添加。",
  "Неизвестная роль.": "未知角色。",
  "Неизвестный статус.": "未知状态。",
  "Сохранено.": "已保存。",
  "Пароль изменён. Сообщите его пользователю.": "密码已修改，请告知用户。",
  "Нельзя удалить самого себя.": "不能删除自己。",
  "Пользователь удалён. Его действия в истории сохранятся.": "用户已删除，其操作记录保留在历史中。",
  "Запрос с другого сайта отклонён.": "已拒绝来自其他网站的请求。",
  "управление пользователями": "管理用户",
  "Сервер не отвечает. Проверьте подключение к интернету или попробуйте позже.": "服务器无响应。请检查网络连接或稍后再试。",
  "OEM повторяется в строках {rows}": "OEM 在第 {rows} 行重复",
  "OEM повторяется в строках {rows}: OEM упаковывается целиком в одну коробку": "OEM 在第 {rows} 行重复：同一 OEM 须整体装入一个箱子"
};
